import {
  CalendarClock,
  LayoutDashboard,
  Package,
  Server,
  ShieldAlert,
  SquareTerminal,
  Ticket,
  UsersRound,
} from 'lucide-react';

export const FEEDBACK_URL = 'https://form.jotform.com/251962873469069';

// `match` lists the path prefixes that belong to an item, so the right item
// stays highlighted on its entity pages.
export const NAV_GROUPS = [
  {
    title: 'Overview',
    items: [
      { label: 'Dashboard', to: '/dashboard', icon: LayoutDashboard, match: ['/dashboard'] },
    ],
  },
  {
    title: 'Investigate',
    items: [
      { label: 'Vulnerabilities', to: '/vulnerabilities', icon: ShieldAlert, match: ['/vulnerabilities'] },
      { label: 'Packages', to: '/packages', icon: Package, match: ['/packages'] },
      { label: 'Hosts', to: '/hosts', icon: Server, match: ['/hosts'] },
      { label: 'Query', to: '/query', icon: SquareTerminal, match: ['/query'] },
    ],
  },
  {
    title: 'Remediate',
    items: [
      { label: 'Tickets', to: '/tickets', icon: Ticket, match: ['/tickets'] },
    ],
  },
  {
    title: 'Manage',
    items: [
      { label: 'Host ownership', to: '/host-ownership', icon: UsersRound, match: ['/host-ownership'] },
      { label: 'Schedules', action: 'openCronSchedule', icon: CalendarClock, match: [] },
    ],
  },
];

const matchesPath = (pathname, prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export const isNavItemActive = (item, pathname) => item.match.some((prefix) => matchesPath(pathname, prefix));
